import { createContext } from 'react';
import type { UserRole, User } from '@/types';

export interface WorkspaceContextValue {
  /** The role determined by the current route */
  effectiveRole: UserRole;
  /** The user object with role/site adjusted for the current route */
  effectiveUser: User;
  /** The workspace route for the current role */
  workspaceRoute: string;
  /** Logged-in users may start user-creation flows */
  canCreateUsers: boolean;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

